// « Photo Vivante » — the album's photos in the order they print, to pick the
// one that comes alive (admin LivingPhotoCard, 2026-11-04). Reads the saved
// layout as is: `{ pages: [...] }` or a bare array; each page lists its photos
// in `photos` and themed pages also in `elements[].photoId`. Pure.
export function photoIdsInPageOrder(pages: unknown): Array<{ id: string; page: number }> {
  const list = Array.isArray(pages) ? pages
    : pages && typeof pages === 'object' && Array.isArray((pages as { pages?: unknown }).pages) ? (pages as { pages: unknown[] }).pages
    : [];
  const out: Array<{ id: string; page: number }> = [];
  const seen = new Set<string>();
  list.forEach((raw, i) => {
    const p = (raw ?? {}) as { page?: unknown; photos?: unknown; elements?: unknown };
    const page = Number.isFinite(Number(p.page)) && Number(p.page) > 0 ? Number(p.page) : i + 1;
    const ids = [
      ...(Array.isArray(p.photos) ? p.photos : []),
      ...(Array.isArray(p.elements) ? p.elements.map((e) => (e as { photoId?: unknown } | null)?.photoId) : []),
    ];
    for (const id of ids) {
      if (typeof id !== 'string' || !id || seen.has(id)) continue;
      seen.add(id);
      out.push({ id, page });
    }
  });
  return out;
}
